<div class="content-container" [attr.data-testid]="ELEMENT_IDS['page']">
    <div class="header-container" [attr.data-testid]="ELEMENT_IDS['hdr']">
        <div class="title">
            <h6 i18n [attr.data-testid]="ELEMENT_IDS['lbl_title']">Forgot Password</h6>
        </div>
        @if(!alreadyHaveVerificationCode) {
        <p class="subtitle" i18n [attr.data-testid]="ELEMENT_IDS['lbl_subtitle']">
            Please enter your login email. A verification code will be sent to your
            registered email address.
        </p>
        } @else {
        <p class="subtitle" i18n [attr.data-testid]="ELEMENT_IDS['lbl_subtitle']">
            Enter the verification code sent to your registered email to change your
            password.
        </p>
        }
    </div>
    @if(!alreadyHaveVerificationCode) {
    <form
        class="form-container"
        [formGroup]="formVerificationCode"
        (ngSubmit)="onSendVerificationCode()"
        [attr.data-testid]="ELEMENT_IDS['form_request_code']"
    >
        <app-custom-input
        label="Login Email"
        controlName="username"
        icon="person"
        iconPlacement="left"
        [elementId]="ELEMENT_IDS['input_username_request']"
        >
        <ng-template #errorsTemplate>
            </ng-template>
        </app-custom-input>

        @if (errorMessage) {
        <p class="error-message" @fadeInOut [attr.data-testid]="ELEMENT_IDS['msg_error_request']">{{errorMessage}}</p>
        }
        <div class="button-container">
            <div class="action-button">
                <app-custom-button
                    [elementId]="ELEMENT_IDS['btn_send_code']"
                    buttonType="primary"
                    text="Send verification code"
                    [loading]="loading"
                    [isSubmit]="true"
                    [disabled]="formVerificationCode.invalid"
                ></app-custom-button>
            </div>
            <div class="back-button">
                <app-custom-button
                    [elementId]="ELEMENT_IDS['btn_back_request']"
                    buttonType="tertiary"
                    text="Back to Login"
                    (onClick)="onBackToLogin()"
                ></app-custom-button>
            </div>
        </div>
    </form>
    } @else {
    <form
        class="form-container"
        [formGroup]="formResetPassword"
        (ngSubmit)="onResetPassword()"
        [attr.data-testid]="ELEMENT_IDS['form_reset']"
    >
        <app-custom-input label="Login Email" controlName="username" icon="person" [hideSubscript]="true" [elementId]="ELEMENT_IDS['input_username_reset']">
            <ng-template #errorsTemplate></ng-template>
        </app-custom-input>

        <span>
            <app-custom-input
                label="Verification Code"
                controlName="verificationCode"
                icon="password"
                iconPlacement="left"
                [hideSubscript]="true"
                [elementId]="ELEMENT_IDS['input_verification_code']"
            >
                <ng-template #errorsTemplate></ng-template>
            </app-custom-input>
            <span class="resend">Didn't receive a code? 
                <span [ngClass]="resendCountdown ? 'resend-countdown' : 'resend-button'" (click)="!loading && !resendCountdown && onSendVerificationCode(true)" [attr.data-testid]="ELEMENT_IDS['lnk_resend_code']">
                    Resend <span *ngIf="resendCountdown">in {{ resendCountdown }}s</span>
                </span>
            </span>
        </span>

        <app-custom-input
            label="New Password"
            controlName="newPassword"
            icon="lock"
            iconPlacement="left"
            [type]="showNewPassword ? 'text' : 'password'"
            [actionIcon]="showNewPassword ? 'visibility' : 'visibility_off'"
            [actionElementId]="ELEMENT_IDS['btn_toggle_new_password']"
            (onActionClick)="toggleShowPassword('new-password')"
            [hideSubscript]="true"
            [elementId]="ELEMENT_IDS['input_new_password']"
        >
            <ng-template #errorsTemplate></ng-template>
        </app-custom-input>

        <app-custom-input
            label="Confirm Password"
            controlName="confirmPassword"
            icon="lock"
            iconPlacement="left"
            [type]="showConfirmPassword ? 'text' : 'password'"
            [actionIcon]="showConfirmPassword ? 'visibility' : 'visibility_off'"
            [actionElementId]="ELEMENT_IDS['btn_toggle_confirm_password']"
            (onActionClick)="toggleShowPassword('confirm-password')"
            [hideSubscript]="true"
            [elementId]="ELEMENT_IDS['input_confirm_password']"
        >
            <ng-template #errorsTemplate></ng-template>
        </app-custom-input>

        @if (errorMessage) {
        <p class="error-message" @fadeInOut [attr.data-testid]="ELEMENT_IDS['msg_error_reset']">{{errorMessage}}</p>
        }

        <ul class="requirement-list" [attr.data-testid]="ELEMENT_IDS['lst_requirements']">
        @for (requirement of passwordRequirements; track requirement.description; let i = $index) {
            <li [attr.data-testid]="ELEMENT_IDS['lst_requirements_item'] + '_' + i">
            <div class="requirement-list-item">
                <!-- Using interpolation on the icon's value causes odd behavior... -->
                @if (requirement.valid) {
                <mat-icon [attr.data-testid]="ELEMENT_IDS['lst_requirements_icon'] + '_' + i" [className]="requirement.valid ? 'requirement-list-item valid' : 'requirement-list-item invalid'" matListItemIcon>check_circle</mat-icon>
                }
                @else {
                <mat-icon [attr.data-testid]="ELEMENT_IDS['lst_requirements_icon'] + '_' + i" [className]="requirement.valid ? 'requirement-list-item valid' : 'requirement-list-item invalid'" matListItemIcon>remove_circle</mat-icon>
                }
                <span [attr.data-testid]="ELEMENT_IDS['lst_requirements_lbl'] + '_' + i">{{ requirement.description }}</span>
            </div>
            </li>
        }
        </ul>
        <div class="button-container">
            <div class="action-button">
                <app-custom-button
                    [elementId]="ELEMENT_IDS['btn_reset_password']"
                    buttonType="primary"
                    text="Reset Password"
                    [loading]="loading"
                    [disabled]="formResetPassword.invalid"
                    [isSubmit]="true"
                ></app-custom-button>
            </div>
            <div class="back-button">
                <app-custom-button
                    [elementId]="ELEMENT_IDS['btn_back_reset']"
                    buttonType="tertiary"
                    text="Back to Login"
                    (onClick)="onBackToLogin()"
                ></app-custom-button>
            </div>
        </div>
    </form>
    }
</div>
